import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class TransctionsOverviewReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            fromDate: null,
            toDate: null,
            configName: 'transactions_overview_report',
        }
    }
    componentDidMount() {
        this.refreshData();
    }
    refreshData() {
        var parentId = this.getCurrentFormId();
        var id = this.getCurrentFormId2();

        this.httpPost("api/v1/report/transactions/overview", {
            id,
            parentId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    getColumns() {
        var t = [];
        t.push({
            field: "title", flex: 2, headerName: "تفصیل", cellRenderer: (props) => {
                if (props.data.tafsilCode <= 0) return null;
                return <a className="text-primary txt-bold hand" href={"/report/transactions/" + props.data.tafsilAccountId + "/" + (this.isBlank(props.data.tafsil2AccountId) ? props.data.tafsilAccountId : props.data.tafsil2AccountId) + "/" + props.data.moeinAccountId + "/"}>
                    {props.data.title}
                </a>
            }
        });
        t.push({ field: "bed", headerName: "گردش بدهکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
        t.push({ field: "bes", headerName: "گردش بستانکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
        t.push({ field: "balance", headerName: "مانده", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.balance) } });
        return t;
    }
    renderForm() {
        return <div className="container">
            <div className="col-sm-2 text-left">
                <ul className="nk-block-tools g-3">
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('تجمیع حسابها')}><span>چاپ</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('تجمیع حسابها')}><span>PDF</span></a>
                    </li>
                    <li>
                        <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('تجمیع حسابها')}><span>اکسل</span></a>
                    </li>
                </ul>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns(),
                pagination: false
            })}
        </div>
    }
    renderPopupForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent">
                        <div className="panel panel-info center-block" style={{ "maxWidth": " none" }}>
                            <div className="modal-header modal-header-info" style={{ "padding": "0" }}>
                                <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">نمایش تجمیعی حساب</h4>
                            </div>
                            <div className="modal-body">
                                {this.renderForm()}
                            </div>
                            <div className="modal-footer">
                                <a className="btn btn-warning" onClick={e => this.closeMe()} > برگشت</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    setAgGridSelectedRow(e) {
        var t = [];
        e.forEach(ee => t.push(ee.id));
        this.state.selectedIds = t;
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                this.state.isPopup ? this.renderPopupForm() : this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}